import {useSelector} from 'Provider';
import React from 'react';

import OfferFilterDestination from 'components/Offers/Filters/Destination';
import {OfferFiltersDestination} from 'models/OfferFilters';
import {destinationsOfferCount} from 'store/offers/offers.selectors';

export interface ConnectedOfferFilterDestinationProps {
  list?: OfferFiltersDestination[];
  selected?: OfferFiltersDestination;
  onSelect?: (item: OfferFiltersDestination) => void;
  toggle?: boolean;
  onToggle?: () => void;
  availableProperties?: string[];
}

const ConnectedOfferFilterDestination: React.FC<
  ConnectedOfferFilterDestinationProps
> = ({
  list = [],
  selected,
  onSelect,
  toggle,
  onToggle,
  availableProperties,
}) => {
  const offersCount = useSelector(destinationsOfferCount);

  return (
    <OfferFilterDestination
      list={list}
      selected={selected}
      onSelect={onSelect}
      toggle={toggle}
      onToggle={onToggle}
      availableProperties={availableProperties}
      offersCount={offersCount}
    />
  );
};

export default ConnectedOfferFilterDestination;
